const TIEN_TO = "thumua_tour_seen_";

function khoaTour(tourId, uid) {
  return uid ? `${TIEN_TO}${uid}_${tourId}` : `${TIEN_TO}${tourId}`;
}

/** Đã xem tour chưa — theo tài khoản (uid) nếu có, tránh máy dùng chung lệch hướng dẫn. */
function daXemTour(tourId, uid) {
  try {
    return window.localStorage.getItem(khoaTour(tourId, uid)) === "1";
  } catch {
    // localStorage bị chặn — coi như đã xem để không làm phiền.
    return true;
  }
}

function danhDauDaXemTour(tourId, uid) {
  try {
    window.localStorage.setItem(khoaTour(tourId, uid), "1");
  } catch {
    // Bỏ qua nếu không ghi được.
  }
}

/** Bỏ bước neo không còn trong DOM (form nháp / tab ẩn / sau khi quét…). */
function locBuocCoTarget(steps) {
  if (!steps?.length || typeof document === "undefined") return steps || [];
  return steps.filter((buoc) => {
    const target = buoc?.target;
    if (!target || typeof target !== "string") return true;
    if (target === "body") return true;
    try {
      return !!document.querySelector(target);
    } catch {
      return false;
    }
  });
}

/** Gắn mặc định skipBeacon để tour tự mở tooltip, không chỉ hiện chấm. */
function chuanHoaBuocTour(steps) {
  return (steps || []).map((buoc) => ({
    skipBeacon: true,
    ...buoc,
  }));
}

export { daXemTour, danhDauDaXemTour, locBuocCoTarget, chuanHoaBuocTour };
